async function handleVote(
	button: HTMLButtonElement,
	answerButtons: NodeListOf<HTMLButtonElement>,
	survey: HTMLElement
) {
	button.querySelector('.checkbox')?.classList.add('checked');
	disableButtons(answerButtons);

	incrementButtonVotes(button);
	const totalVotes: number = incrementTotalVotes(survey);
	updateProgressBars(answerButtons, totalVotes);

	const answerId: string = button.dataset.answerId;
	const surveyId: string = survey.dataset.surveyId;
	await submitVote(surveyId, answerId);
}

function disableButtons(answerButtons: NodeListOf<HTMLButtonElement>): void {
	answerButtons.forEach((btn: HTMLButtonElement) => {
		btn.classList.add('show-results');
		btn.disabled = true;
	});
}

function incrementTotalVotes(survey: HTMLElement): number {
	let totalVotes: number = parseInt(survey.dataset.totalVotes);
	totalVotes += 1;
	const totalVotesElement: HTMLElement = survey.querySelector('.total-votes .value');
	if (totalVotesElement) {
		totalVotesElement.textContent = `${totalVotes}`;
	}
	return totalVotes;
}

function incrementButtonVotes(button: HTMLButtonElement): void {
	const voteCount: number = parseInt(button.dataset.vote);
	button.dataset.vote = (voteCount + 1).toString();
}

function updateProgressBars(
	answerButtons: NodeListOf<HTMLButtonElement>,
	totalVotes: number
): void {
	answerButtons.forEach((btn: HTMLButtonElement) => {
		const count: number = parseInt(btn.dataset.vote);
		const progress: HTMLProgressElement = btn.querySelector('progress');
		const percentageElement: HTMLElement = btn.querySelector('.percentage');
		const percentage: number = Math.round((count / totalVotes) * 100);
		progress.value = count;
		progress.max = totalVotes;
		percentageElement.textContent = `${percentage}\u00A0%`;
	});
}

async function submitVote(surveyId: string, answerId: string): Promise<void> {
	try {
		const response: Response = await fetch('/wp-submit-vote', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
			body: new URLSearchParams({
				action: 'submit_vote',
				survey_id: surveyId,
				answer_id: answerId,
			}),
		});
		const data: { success: boolean } = await response.json();
		if (data.success) {
			localStorage.setItem(`survey_${surveyId}`, answerId);
		}
	} catch (error) {}
}

function initializeSurvey(survey: HTMLElement): void {
	const answerButtons: NodeListOf<HTMLButtonElement> = survey.querySelectorAll('.answer');

	// Check if already voted
	const surveyId: string = survey.dataset.surveyId;
	const votedAnswerId: string = localStorage.getItem(`survey_${surveyId}`);
	if (votedAnswerId) {
		disableButtons(answerButtons);
		answerButtons.forEach((button: HTMLButtonElement) => {
			if (button.dataset.answerId === votedAnswerId) {
				button.querySelector('.checkbox')?.classList.add('checked');
			}
		});
		return;
	}

	answerButtons.forEach((button: HTMLButtonElement) => {
		button.addEventListener('click', () => handleVote(button, answerButtons, survey));
	});
}

document.querySelectorAll('.wp-block-psg-survey').forEach(initializeSurvey);
